import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import I18n from '../../../resources/i18n/I18n'

const ModalEdition = ({ showModal, toggleModal, item, editLabel, modifyItemLabel, modifyItemCode, title }) => {
  const [errorLabel, setErrorLabel] = useState(false)
  const [errorCode, setErrorCode] = useState(false)

  const handleEditLabel = () => {
    if (!item.label) {
      setErrorLabel(I18n.t('Required'))
    } else {
      setErrorLabel(false)
    }

    if (!item.code) {
      setErrorCode(I18n.t('Required'))
    } else {
      setErrorCode(false)
    }

    if (item.label && item.code) {
      editLabel().then((result) => {
        if (result && result.description) {
          setErrorCode(result.description.message)
        } else {
          handleClose()
        }
      })
    }
  }

  const handleClose = () => {
    setErrorLabel(false)
    setErrorCode(false)
    toggleModal()
  }

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title ? title : I18n.t('EditConfirmTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>{I18n.t('Label')}</Form.Label>
          <Form.Control value={item ? item.label : ''} onChange={(e) => modifyItemLabel(e.target.value)} />
          {errorLabel && <Form.Text className="error">{errorLabel}</Form.Text>}
        </Form.Group>
        <Form.Group>
          <Form.Label>{I18n.t('Code')}</Form.Label>
          <Form.Control value={item ? item.code : ''} onChange={(e) => modifyItemCode(e.target.value)} />
          {errorCode && <Form.Text className="error">{errorCode}</Form.Text>}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-back" onClick={handleClose}>
          {I18n.t('ModalConfirmCancel')}
        </Button>
        <Button className="primary" onClick={handleEditLabel}>
          {I18n.t('ModalConfirmOk')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalEdition
